var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-image',{staticStyle:{"display":"block","-webkit-touch-callout":"none"},attrs:{"fit":_vm.fit,"height":_vm.height,"width":_vm.width,"radius":_vm.radius,"src":_vm.src},on:{"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }